<div *ngIf="dataSource$ | async as dataSource" style="display: flex; flex-direction: column; height: 100%;">
  <div style="flex-grow: 1; display: flex; flex-direction: column; overflow: hidden;">
    <div style="padding: 0 35px; display: flex; justify-content: end; gap: 10px; position: sticky; top: 0; z-index: 1;">
      <div *ngIf="hideTerminatedServers$ | async">
        <button class="action-button" mat-button aria-label="Clear"
                *inRole="[roles.Administrator]"
                matTooltip="Currently only showing active servers. Terminated servers are hidden."
                (click)="setHideTerminated(false)"
                style="transition: 350ms ease-in-out; background: #3f51b5; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-display-slash"></span>
          <span style="padding-left: 10px;">Show All Servers</span>
        </button>
      </div>
      <div *ngIf="(hideTerminatedServers$ | async) === false">
        <button class="action-button" mat-button aria-label="Clear"
                *inRole="[roles.Administrator]"
                matTooltip="Currently showing all servers."
                (click)="setHideTerminated(true)"
                style="transition: 350ms ease-in-out; background: #3f51b5; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-display"></span>
          <span style="padding-left: 10px;">Hide Terminated Servers</span>
        </button>
      </div>
      <button class="action-button" mat-button aria-label="Clear"
              *inRole="[roles.Administrator]"
              (click)="startAll()"
              style="transition: 350ms ease-in-out; background: #1e6500; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
        <span class="fal fa-play"></span>
        <span style="padding-left: 10px;">Start All</span>
      </button>
      <button class="action-button" mat-button aria-label="Clear"
              *inRole="[roles.Administrator]"
              (click)="stopAll()"
              style="transition: 350ms ease-in-out; background: #f44336; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
        <span class="fal fa-stop"></span>
        <span style="padding-left: 10px;">Stop All</span>
      </button>
      <button class="action-button" mat-button aria-label="Clear"
              *inRole="[roles.Administrator]"
              routerLink="/admin/server-configuration"
              style="transition: 350ms ease-in-out; background: #525252; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
        <span class="fal fa-cogs"></span>
        <span style="padding-left: 10px;">Server Configuration</span>
      </button>
    </div>
    <!-- Table Container -->
    <div style="padding: 0 35px; flex-grow: 1; overflow-y: auto;" *ngIf="dataSource.data.length > 0">
      <table mat-table matSort (matSortChange)="sort($event)" [dataSource]="dataSource" class="table-width"
             [trackBy]="trackByFn" style="width: 100%; border-spacing: 0 3px; background: transparent;">
        <ng-container matColumnDef="controls">
          <th mat-header-cell *matHeaderCellDef style="width: 8%; font-size: 14px"></th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px">
            <div *ngIf="element.isStop" (click)="toggleState(element)" style="display: flex; gap: 10px; align-items: center; cursor: pointer;">
              <span class="fal fa-play"></span> <span>Start Instance</span>
            </div>
            <div *ngIf="element.isAvailableForProcessing" (click)="toggleState(element)" style="display: flex; gap: 10px; align-items: center; cursor: pointer;">
              <span class="fal fa-stop" style="color: #f44336"></span> <span>Stop Instance</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 8%; font-size: 14px" mat-sort-header="instanceId">Instance</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px">{{element.instanceId}}</td>
        </ng-container>
        <ng-container matColumnDef="ip">
          <th mat-header-cell *matHeaderCellDef style="width: 5%;font-size: 14px" mat-sort-header="serverIP">IP Address</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px; ">{{element.serverIP}}<span class="fal fa-copy" style="padding-left:10px; cursor: pointer;" (click)="copyTextToClipboard(element.serverIP)"></span></td>
        </ng-container>
		  <ng-container matColumnDef="version">
			  <th mat-header-cell *matHeaderCellDef style="width: 5%;font-size: 14px" mat-sort-header="version">Version</th>
			  <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
				  style="font-size: 14px; min-width: 250px;">{{ element.assemblyVersion }}</td>
		  </ng-container>
		  <ng-container matColumnDef="memory">
			  <th mat-header-cell *matHeaderCellDef style="width: 5%;font-size: 14px" mat-sort-header="memory">Memory %</th>
			  <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
				  style="font-size: 14px">{{ element.availableMemoryInMB | FriendlyBytes}}</td>
		  </ng-container>
        <ng-container matColumnDef="lastPing">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px" mat-sort-header="lastPing">Last Ping</th>
          <td mat-cell [ngClass]="{'old-ping': isPingOld(element)}" *matCellDef="let element"
              [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.lastPing | DateAgo}}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef style="width: 8%; font-size: 14px" mat-sort-header="serverType.displayName">Type</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px">{{element.serverType.displayName}}</td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px" mat-sort-header="serverState.displayName">State</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px">{{element.serverState.displayName}}</td>
        </ng-container>
        <ng-container matColumnDef="lastStateChange">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px" mat-sort-header="serverStateTimestamp">Last State Change</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
              style="font-size: 14px">{{element.serverStateTimestamp | DateAgo}}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay" [style.height.px]="rowHeight$ | async"></tr>
      </table>
    </div>
    <!-- No Data Container -->
    <div *ngIf="dataSource.data.length < 1">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
        <span class="fal fa-binary-circle-check"></span>
        <span style="padding-left: 10px;">No Servers Running.</span>
      </div>
    </div>
  </div>
</div>
